import { render, staticRenderFns } from "./ShortlistList.vue?vue&type=template&id=1d58e45c&"
import script from "./ShortlistList.vue?vue&type=script&lang=js&"
export * from "./ShortlistList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports